import { observable, toJS } from 'mobx';

export default class ChannelModel {
    id = null;
    @observable type = null;
    @observable name = null;
    
    @observable settings = null;

    @observable logs = null;

    @observable createdAt = null;
    @observable updatedAt = null;

    auth = null;


    constructor(auth, id, type, name, settings) {
        this.auth = auth;

        this.id = id;
        this.type = type;
        this.name = name;
        this.settings = settings;
    }

    toJS() {
        toJS(this);
    }

    static fromJS(auth, object) {
        return new ChannelModel(auth, object.id, object.type, object.name, object.settings);
    }
}
